import styled from 'styled-components'
import AspectRatioComponent from './aspect-ratio'
import ResizeComponent from './resize'

export const AspectRatio = styled(AspectRatioComponent)`
    grid-column: span 8;
`

export const Resize = styled(ResizeComponent)`
    grid-column: span 2;
`
